import React from 'react';
import LoadingBar from 'components/BarLoader';
import ModalHeader from 'components/Modal/Header';
import utils from 'utils';
interface Props {
  percentage: number;
  name: string;
}

function Progress(props: Props) {
  const { name, percentage } = props;
  const t = utils.intl.useTranslator();

  return (
    <>
      <ModalHeader title={t('file uploading')} subtitle={`${name}: ${t('please-wait')}`} />
      <LoadingBar currentPercentage={percentage} />
    </>
  );
}

export default Progress;
